export default __webpack_public_path__ + "static/media/Coinstack.7835cba6.png";